var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useMemo, useState } from 'react';
import { api } from '../../../include/network/network';
function cacheKey(price) {
    return JSON.stringify([price.secureSerialized, price.begin, price.end, price.currencyId]);
}
export function useHotelVariants(prices, open) {
    const [loaded, setLoaded] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        let cancelled = false;
        const pending = prices.filter(price => price.hasVariants && price.externalProviderId && price.bookingCode && !loaded[cacheKey(price)]);
        setLoading(open && pending.length > 0);
        setError(false);
        if (!open || !pending.length)
            return;
        Promise.all(pending.map((price) => __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield api('post', '/NewHotel/Variants', {
                    room: price.secureSerialized,
                    checkIn: price.begin,
                    checkOut: price.end,
                    roomNo: price.roomNo || 1,
                    allRoomNos: price.allRoomNos,
                });
                if (result.errors || !Array.isArray(result.response))
                    throw new Error('Hotel variants are unavailable');
                if (!cancelled)
                    setLoaded(previous => (Object.assign(Object.assign({}, previous), { [cacheKey(price)]: result.response })));
            }
            catch (_a) {
                if (!cancelled)
                    setError(true);
            }
        }))).then(() => {
            if (!cancelled)
                setLoading(false);
        });
        return () => { cancelled = true; };
        // Loaded results persist across toggles. A new search supplies new signed room tokens.
    }, [prices, open, attempt]);
    const expandedPrices = useMemo(() => {
        const seen = new Set();
        return prices.flatMap(original => {
            const variants = loaded[cacheKey(original)];
            return (variants === null || variants === void 0 ? void 0 : variants.length) ? variants.map(variant => {
                var _a, _b;
                return (Object.assign(Object.assign(Object.assign({}, original), variant), { priceRub: (_a = variant.priceRub) !== null && _a !== void 0 ? _a : null, countryId: original.countryId, categoryId: original.categoryId, roomNo: original.roomNo, allRoomNo: original.allRoomNo, allRoomNos: original.allRoomNos, hotelName: variant.hotelName || original.hotelName, categoryName: variant.categoryName || original.categoryName, cityName: variant.cityName || original.cityName, accommodations: ((_b = variant.accommodations) === null || _b === void 0 ? void 0 : _b.length) ? variant.accommodations : original.accommodations }));
            }) : [original];
        }).filter(price => {
            if (!price.externalProviderId || !price.bookingCode)
                return true;
            const key = JSON.stringify([price.externalProviderId, price.bookingCode, price.currencyId, price.begin, price.end, price.allRoomNo, price.roomNo]);
            if (seen.has(key))
                return false;
            seen.add(key);
            return true;
        });
    }, [prices, loaded]);
    return { prices: expandedPrices, loading, error, retry: () => setAttempt(value => value + 1) };
}
